export type TravellerDocType = 'PASSPORT' | 'NATIONALID' | 'IQAMA'

export const DOC_TYPE_ORDER: TravellerDocType[] = ['PASSPORT', 'NATIONALID', 'IQAMA']

export interface TravellerDocDetail {
    docType: TravellerDocType
    docNumber: string
    nationality: string
    countryIssued: string
    expiryDate: string
    dateOfBirth: string
}

export interface TravellerPhone {
    countryCode: string
    number: string
}

export interface TravellerData {
    id: number
    isRegistered: boolean
    title: string
    firstName: string
    lastName: string
    gender: string
    dateOfBirth: string
    email: string
    phone: TravellerPhone
    documents: TravellerDocDetail[]
}
